module.exports = __webpack_public_path__ + "img/use-app-4.5180d766.jpg";